import { render, staticRenderFns } from "./Metas.vue?vue&type=template&id=5fd01a21"
import script from "./Metas.vue?vue&type=script&lang=js"
export * from "./Metas.vue?vue&type=script&lang=js"
import style0 from "./Metas.vue?vue&type=style&index=0&id=5fd01a21&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports